// ~120 major world cities for autocomplete fallback (V1 - replace with Mapbox in V2)
export const CITIES = [
  "Paris, France","Lyon, France","Marseille, France","Toulouse, France","Nice, France","Nantes, France","Bordeaux, France","Strasbourg, France","Lille, France","Rennes, France",
  "London, United Kingdom","Manchester, United Kingdom","Edinburgh, United Kingdom","Dublin, Ireland",
  "Berlin, Germany","Munich, Germany","Frankfurt, Germany","Hamburg, Germany","Cologne, Germany",
  "Madrid, Spain","Barcelona, Spain","Valencia, Spain","Seville, Spain","Bilbao, Spain",
  "Rome, Italy","Milan, Italy","Naples, Italy","Turin, Italy","Florence, Italy","Venice, Italy",
  "Amsterdam, Netherlands","Rotterdam, Netherlands","The Hague, Netherlands",
  "Brussels, Belgium","Antwerp, Belgium",
  "Zurich, Switzerland","Geneva, Switzerland","Bern, Switzerland",
  "Vienna, Austria","Salzburg, Austria",
  "Lisbon, Portugal","Porto, Portugal",
  "Athens, Greece","Prague, Czechia","Budapest, Hungary","Warsaw, Poland","Krakow, Poland","Copenhagen, Denmark","Stockholm, Sweden","Oslo, Norway","Helsinki, Finland","Reykjavik, Iceland",
  "Istanbul, Turkey","Ankara, Turkey",
  "Moscow, Russia","Saint Petersburg, Russia",
  "New York, USA","Los Angeles, USA","Chicago, USA","San Francisco, USA","Miami, USA","Boston, USA","Washington DC, USA","Seattle, USA","Houston, USA","Dallas, USA",
  "Toronto, Canada","Montreal, Canada","Vancouver, Canada",
  "Mexico City, Mexico","Cancun, Mexico",
  "São Paulo, Brazil","Rio de Janeiro, Brazil",
  "Buenos Aires, Argentina","Santiago, Chile","Lima, Peru","Bogotá, Colombia",
  "Tokyo, Japan","Osaka, Japan","Kyoto, Japan",
  "Seoul, South Korea","Beijing, China","Shanghai, China","Hong Kong, Hong Kong","Taipei, Taiwan",
  "Singapore, Singapore","Bangkok, Thailand","Kuala Lumpur, Malaysia","Jakarta, Indonesia","Manila, Philippines","Hanoi, Vietnam","Ho Chi Minh City, Vietnam",
  "Mumbai, India","New Delhi, India","Bangalore, India","Chennai, India","Kolkata, India",
  "Dubai, UAE","Abu Dhabi, UAE","Doha, Qatar","Riyadh, Saudi Arabia","Tel Aviv, Israel","Amman, Jordan",
  "Cairo, Egypt","Casablanca, Morocco","Marrakech, Morocco","Tunis, Tunisia","Algiers, Algeria","Dakar, Senegal","Abidjan, Côte d'Ivoire","Lagos, Nigeria","Nairobi, Kenya","Cape Town, South Africa","Johannesburg, South Africa",
  "Sydney, Australia","Melbourne, Australia","Brisbane, Australia","Auckland, New Zealand",
];

export function suggestCities(q) {
  if (!q || q.length < 1) return [];
  const s = q.toLowerCase();
  return CITIES.filter((c) => c.toLowerCase().includes(s)).slice(0, 8);
}
